// extracted by mini-css-extract-plugin
export var activeProfiles = "platform-card-module--activeProfiles--a8d45";
export var activeProfilesSubText = "platform-card-module--activeProfilesSubText--e8ead";
export var asterisk = "platform-card-module--asterisk--5219d";
export var button = "platform-card-module--button--994c7";
export var buttonContainer = "platform-card-module--buttonContainer--7b7a1";
export var cardContents = "platform-card-module--cardContents--70e96";
export var contentContainer = "platform-card-module--contentContainer--7580c";
export var description = "platform-card-module--description--a929a";
export var discount = "platform-card-module--discount--d4192";
export var divider = "platform-card-module--divider--39734";
export var featuresListContainer = "platform-card-module--featuresListContainer--7c3db";
export var introPrice = "platform-card-module--introPrice--65c21";
export var pillText = "platform-card-module--pillText--37881";
export var pillTextContainer = "platform-card-module--pillTextContainer--6ec22";
export var planName = "platform-card-module--planName--694df";
export var planNameContainer = "platform-card-module--planNameContainer--a4f60";
export var platformCard = "platform-card-module--platformCard--c9cec";
export var price = "platform-card-module--price--7c88f";
export var priceDescription = "platform-card-module--priceDescription--3bbf3";
export var priceInfo = "platform-card-module--priceInfo--354d6";
export var priceWrapper = "platform-card-module--priceWrapper--a2915";
export var sliderWrapper = "platform-card-module--sliderWrapper--b6720";
export var timePeriod = "platform-card-module--timePeriod--8e5d9";